import React from 'react';

import { Link } from 'react-router-dom';


function LinkItem({ url, newTab, classList, tag, onClick }) {
  const Component = tag;

  if (onClick)
    return (
      <div
        className={classList}
        onClick={onClick}
      >
        <Component />
      </div>
    )
  return (

    <Link
      to={newTab ? { pathname: url } : url}
      rel="noopener noreferrer"
      target={newTab && '_blank'}
      className={classList}
      onClick={onClick}
    >
      <Component />
    </Link>
  )
}

export default LinkItem
